<script setup>
import { questionarioPage } from '@/graphql/queries/questionario.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(questionarioPage, variables)

if (!data.value.questionario) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value.questionario)

const seo = computed(() => page?.value.seo || {})
useSeo(seo)
</script>

<template>
  <div class="questionario-page p-top-1a p-bot-1">
    <p v-if="page.titolo" class="intro-page-title text-3 row-400-20 max">
      {{ page.titolo }}
    </p>
    <IntroPagine v-if="page.intro" :intro="page.intro" />
  </div>
</template>
